import "./app.css";
import App from "./App.svelte";
import { mount } from "svelte";

function readAuthMode() {
  // Prefer the specific module script tag (works even if other scripts exist)
  const script =
    document.querySelector('script[type="module"][src$="/src/main.js"]') ||
    document.currentScript;

  const raw = (script?.dataset?.authenticate ?? "")
    .toString()
    .trim()
    .toLowerCase();

  // Only explicit truthy tokens enable auth mode.
  return raw === "true" || raw === "1" || raw === "yes" || raw === "on";
}

const target = document.getElementById("app");
if (target) {
  mount(App, {
    target,
    props: {
      authMode: readAuthMode()
    }
  });
}
